import { Deserializable } from '../deserializable';

export class CaseAdministratorRightDto implements Deserializable {
  public CaseAdministratorID: number;
  public NotSelectable: boolean;
  public IsChanged: boolean;
  public Right: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
